import { Box, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';

// Status pill: green when connected, red otherwise
const ConnectionIndicator = ({
  connected
}) => {
  return (
    <Box sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.75,
      px: 1.25,
      py: 0.5,
      borderRadius: "999px",
      backgroundColor: connected ? "var(--c-success-bg)" : "var(--c-danger-bg)",
      color: connected ? "var(--c-success)" : "var(--c-danger)",
      whiteSpace: "nowrap",
    }}>
      {connected
        ? <LinkIcon sx={{ fontSize: 16 }} />
        : <LinkOffIcon sx={{ fontSize: 16 }} />
      }
      <Typography sx={{ fontSize: 12, fontWeight: 600, lineHeight: 1.5 }}>
        {connected ? "Connected" : "Disconnected"}
      </Typography>
    </Box>
  )
}

export default ConnectionIndicator
